export { default } from './PremiumAnalysis';
